export default function timeAgo(
  date: Date,
  dateStyle: 'medium' | 'short' = 'short',
): string {
  const now = new Date()
  const secondsPast = (now.getTime() - date.getTime()) / 1000
  if (secondsPast < 60) {
    return '1 دقیقه پیش'
  }
  if (secondsPast < 3600) {
    const minutes = Math.round(secondsPast / 60)
    return `${minutes} دقیقه پیش`
  }
  if (secondsPast < 86400) {
    const hours = Math.round(secondsPast / 3600)
    return `${hours} ساعت پیش`
  }
  if (secondsPast <= 259200) {
    const days = Math.round(secondsPast / 86400)
    return `${days} روز پیش`
  }
  return new Intl.DateTimeFormat('fa-IR', { dateStyle }).format(date)
}
